(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.SSCartUpsellRules = api;
})(typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var OWN_PREFIX = '_ss_cu_';
  var UPSELL_HANDLES = [
    'matching-bracelet-your-custom-pet-owner-design',
    'everyday-connection-cord-charm-bracelet'
  ];

  function normalized(value) {
    return String(value == null ? '' : value).trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function sourceProperties(item) {
    var original = item && item.properties;
    var result = {};
    if (!original || typeof original !== 'object' || Array.isArray(original)) return result;
    Object.keys(original).forEach(function (key) {
      if (key.indexOf(OWN_PREFIX) === 0) return;
      Object.defineProperty(result, key, {
        value: original[key], enumerable: true, configurable: true, writable: true
      });
    });
    return result;
  }

  function canonical(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) return '[' + value.map(function (entry) {
      var serialized = canonical(entry);
      return serialized === undefined ? 'null' : serialized;
    }).join(',') + ']';
    return '{' + Object.keys(value).sort().filter(function (key) {
      return value[key] !== undefined;
    }).map(function (key) {
      return JSON.stringify(key) + ':' + canonical(value[key]);
    }).join(',') + '}';
  }

  function hash(value) {
    var first = 2166136261;
    var second = 3339675911;
    for (var i = 0; i < value.length; i += 1) {
      first = Math.imul(first ^ value.charCodeAt(i), 16777619);
      second = Math.imul(second ^ value.charCodeAt(i), 2246822519);
    }
    return ('00000000' + (first >>> 0).toString(16)).slice(-8) +
      ('00000000' + (second >>> 0).toString(16)).slice(-8);
  }

  function itemHandle(item) {
    if (item.handle || item.product_handle) return normalized(item.handle || item.product_handle);
    var match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? normalized(match[1]) : '';
  }

  function classify(item) {
    var title = String(item.product_title || item.title || '');
    var type = String(item.product_type || item.type || '');
    var tags = Array.isArray(item.tags) ? item.tags : String(item.tags || '').split(',');
    var necklaceTag = tags.some(function (tag) { return /^necklaces?$/.test(normalized(tag)); });
    if (/\bnecklaces?\b/i.test(title + ' ' + type) || necklaceTag) return 'necklace';
    // Charm products can include a bracelet set; wording and order vary between designs.
    if (/^charms?$/.test(normalized(type)) &&
        /\bbracelets?\s+sets?\b/i.test(title)) return 'charm';
    if (/\b(?:bracelets?|earrings?|earings?)\b/i.test(title + ' ' + type) || tags.some(function (tag) {
      return /^(?:bracelets?|earrings?|earings?)$/.test(normalized(tag));
    })) return null;
    if (/\bcharms?\b/i.test(title + ' ' + type) || tags.some(function (tag) {
      return /^charms?$/.test(normalized(tag));
    })) return 'charm';
    return null;
  }

  function itemMaterial(item) {
    var options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    var material = options.find(function (option) { return normalized(option.name) === 'material'; });
    if (material && normalized(material.value)) return normalized(material.value);
    var properties = sourceProperties(item);
    var key = Object.keys(properties).find(function (name) { return normalized(name) === 'material'; });
    return key === undefined ? '' : normalized(properties[key]);
  }

  function optionIndex(product, name) {
    return (Array.isArray(product.options) ? product.options : []).findIndex(function (option) {
      return normalized(typeof option === 'string' ? option : option.name) === name;
    });
  }

  function variantOption(variant, index) {
    if (index < 0) return undefined;
    return Array.isArray(variant.options) ? variant.options[index] : variant['option' + (index + 1)];
  }

  function matchingVariant(product, material) {
    if (!product || !material || !Array.isArray(product.variants)) return null;
    var materialIndex = optionIndex(product, 'material');
    if (materialIndex < 0) return null;
    return product.variants.find(function (variant) {
      return variant.available === true && normalized(variantOption(variant, materialIndex)) === material;
    }) || null;
  }

  function imageUrl(value) {
    return typeof value === 'string' ? value : value && (value.src || value.url) || '';
  }

  function variantId(item) {
    return String(item.variant_id == null ? item.id : item.variant_id);
  }

  function buildOffers(cart, catalog) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    catalog = catalog || {};
    var excludedIds = [catalog.necklace, catalog.charm].filter(Boolean).map(function (product) {
      return String(product.id);
    });
    var seen = Object.create(null);
    var offers = [];

    items.forEach(function (source) {
      if (Number(source.quantity) <= 0 || excludedIds.indexOf(String(source.product_id)) !== -1 ||
          UPSELL_HANDLES.indexOf(itemHandle(source)) !== -1) return;
      var kind = classify(source);
      if (!kind) return;
      var product = catalog[kind];
      var variant = matchingVariant(product, itemMaterial(source));
      if (!variant) return;

      var copied = kind === 'necklace' ? sourceProperties(source) : {};
      var sourceTitle = kind === 'necklace' ? String(source.product_title || source.title || '') : '';
      var sourceProductId = source.product_id == null ? null : source.product_id;
      var sourceIdentity = String(sourceProductId == null ? itemHandle(source) || sourceTitle : sourceProductId);
      var identity = kind === 'necklace'
        ? canonical([String(variant.id), sourceIdentity, copied])
        : canonical([String(variant.id)]);
      var id = 'sscu-' + kind + '-' + hash(identity);
      if (seen[id]) return;
      seen[id] = true;

      var originalCanonical = canonical(copied);
      var properties = sourceProperties({ properties: copied });
      properties._ss_cu_offer = id;
      properties._ss_cu_kind = kind;
      if (kind === 'necklace') {
        properties._ss_cu_source_product = sourceIdentity;
        properties._ss_cu_source_title = sourceTitle;
      }
      var addedLineKeys = [];
      var externalAdded = false;
      items.forEach(function (existing) {
        if (Number(existing.quantity) <= 0 || variantId(existing) !== String(variant.id)) return;
        var existingProperties = existing.properties || {};
        if (existingProperties._ss_cu_offer === id) {
          if (existing.key != null) addedLineKeys.push(existing.key);
          return;
        }
        if (existingProperties._ss_cu_offer) return;
        if (kind === 'charm') {
          externalAdded = true;
          return;
        }
        if (canonical(sourceProperties(existing)) !== originalCanonical) return;
        var proof = existingProperties._ss_cu_source_product;
        if (proof != null && String(proof) !== sourceIdentity) return;
        // An unpersonalized manual bracelet cannot prove which necklace design it matches.
        if (proof == null && Object.keys(copied).length === 0) return;
        externalAdded = true;
      });

      offers.push({
        id: id,
        kind: kind,
        productId: product.id,
        variantId: variant.id,
        title: String(product.title || ''),
        handle: String(product.handle || UPSELL_HANDLES[kind === 'necklace' ? 0 : 1]),
        material: String(variantOption(variant, optionIndex(product, 'material')) || ''),
        price: variant.price,
        compareAtPrice: variant.compare_at_price == null ? null : variant.compare_at_price,
        image: imageUrl(variant.featured_image || variant.image) ||
          imageUrl(product.featured_image) || imageUrl((product.images || [])[0]),
        sourceTitle: sourceTitle,
        sourceProductId: sourceProductId,
        properties: properties,
        addedLineKeys: addedLineKeys,
        externalAdded: externalAdded
      });
    });
    return offers;
  }

  return { buildOffers: buildOffers };
});
